"use client";

import { c as _c } from "react/compiler-runtime";
import { INotificationIdentityMentioned } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationHeader from "../subcomponents/NotificationHeader";
import { useWaveNavigation, getIsDirectMessage } from "../utils/navigationUtils";
export default function NotificationIdentityMentioned(t0) {
  const $ = _c(30);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    navigateToWave,
    createQuoteClickHandler
  } = useWaveNavigation();
  const baseWave = notification.related_drops[0].wave;
  let onReplyClick;
  let t1;
  if ($[0] !== baseWave || $[1] !== createQuoteClickHandler || $[2] !== navigateToWave) {
    const baseIsDm = getIsDirectMessage(baseWave);
    onReplyClick = serialNo => {
      navigateToWave(baseWave.id, serialNo, baseIsDm);
    };
    t1 = createQuoteClickHandler(baseIsDm);
    $[0] = baseWave;
    $[1] = createQuoteClickHandler;
    $[2] = navigateToWave;
    $[3] = onReplyClick;
    $[4] = t1;
  } else {
    onReplyClick = $[3];
    t1 = $[4];
  }
  const onQuoteClick = t1;
  const t2 = notification.related_drops[0].author;
  let t3;
  if ($[5] !== notification.related_drops[0].author) {
    t3 = <NotificationsFollowBtn profile={notification.related_drops[0].author} size={UserFollowBtnSize.SMALL} />;
    $[5] = notification.related_drops[0].author;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">mentioned you</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== notification.created_at) {
    t6 = getTimeAgoShort(notification.created_at);
    $[9] = notification.created_at;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t5}{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== notification.related_drops[0].author || $[14] !== t3 || $[15] !== t7) {
    t8 = <NotificationHeader author={t2} actions={t3}>{t4}{t7}</NotificationHeader>;
    $[13] = notification.related_drops[0].author;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== notification.related_drops[0]) {
    t9 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[17] = notification.related_drops[0];
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== activeDrop || $[20] !== onDropContentClick || $[21] !== onQuote || $[22] !== onQuoteClick || $[23] !== onReply || $[24] !== onReplyClick || $[25] !== t9) {
    t10 = <Drop drop={t9} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[19] = activeDrop;
    $[20] = onDropContentClick;
    $[21] = onQuote;
    $[22] = onQuoteClick;
    $[23] = onReply;
    $[24] = onReplyClick;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t8) {
    t11 = <div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t8}{t10}</div>;
    $[27] = t10;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}